import { useMutation } from 'react-query';
import api from '../../global/api';
import { pick } from '../pick/pick';

import {
  S3FileUploadType,
  S3GetSignedFilesRequest,
  S3GetSignedFilesResponse,
} from './s3-types';

export const useGetS3SignedFile = (
  orderId: string,
  type: S3FileUploadType,
  fileName?: string,
) => {
  const [mutate, { ...rest }] = useMutation(
    async (params: S3GetSignedFilesRequest) => {
      const response = await api.post<S3GetSignedFilesResponse>(
        `/files/get/${type}`,
        pick(params, ['files', 'id']),
      );

      return response.data;
    },
  );

  const open = async () => {
    if (!fileName) {
      return;
    }

    const data = await mutate({
      id: orderId,
      files: [
        {
          id: orderId,
          name: fileName,
        },
      ],
      type,
    });

    if (data) {
      window.open(data.files[0].url, '_blank');
    }
  };

  return {
    open,
    ...rest,
  };
};
